import { useEffect, useState } from 'react';
import { Button } from './ui/button';
import { Download } from 'lucide-react';

const InstallPWA = () => {
  const [deferredPrompt, setDeferredPrompt] = useState(null);
  const [showInstallButton, setShowInstallButton] = useState(false);

  useEffect(() => {
    // Ascolta l'evento beforeinstallprompt
    const handleBeforeInstallPrompt = (e) => {
      // Previeni il prompt automatico
      e.preventDefault();
      // Salva l'evento per usarlo dopo
      setDeferredPrompt(e);
      // Mostra il pulsante di installazione
      setShowInstallButton(true);
    };

    window.addEventListener('beforeinstallprompt', handleBeforeInstallPrompt);

    // Controlla se l'app è già installata
    if (window.matchMedia('(display-mode: standalone)').matches) {
      setShowInstallButton(false);
    }

    return () => {
      window.removeEventListener('beforeinstallprompt', handleBeforeInstallPrompt);
    };
  }, []);

  const handleInstallClick = async () => {
    if (!deferredPrompt) {
      return;
    }

    // Mostra il prompt di installazione
    deferredPrompt.prompt();

    // Aspetta che l'utente risponda al prompt
    const { outcome } = await deferredPrompt.userChoice;
    
    console.log(`Utente ha risposto al prompt di installazione: ${outcome}`);

    // Nascondi il pulsante dopo l'installazione
    setDeferredPrompt(null);
    setShowInstallButton(false);
  };

  if (!showInstallButton) {
    return null;
  }

  return (
    <Button
      onClick={handleInstallClick}
      variant="outline"
      size="sm"
      className="flex items-center gap-2"
    >
      <Download className="h-4 w-4" />
      Installa App
    </Button>
  );
};

export default InstallPWA;
